import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const dashboardService = createApi({
  reducerPath: "dashboardService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getSaleAmount: builder.query<
      any,
      {
        merchants: string[];
        date_from?: string;
        date_to?: string;
        currency?: string;
        previous_date_from?: string;
        previous_date_to?: string;
      }
    >({
      query: (params) => ({
        url: `/dashboard/saleAmount`,
        params: params,
        method: "GET",
      }),
    }),
    getRefundAmount: builder.query<
      any,
      {
        merchants: string[];
        date_from?: string;
        date_to?: string;
        currency?: string;
        previous_date_from?: string;
        previous_date_to?: string;
      }
    >({
      query: (params) => ({
        url: `/dashboard/refundAmount`,
        params: params,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetRefundAmountQuery, useLazyGetSaleAmountQuery } = dashboardService;
